import * as types from '../../../actions/candidate/candidate-references/types';
import Immutable from 'immutable';
import reducerCreator from '../../../tools/reducer-creator';
import {candidateReferencesStateKeys} from '../../../constants/candidate-references'

const initialState = Immutable.fromJS({
  [candidateReferencesStateKeys.candidateReferences]: null,
  [candidateReferencesStateKeys.isLoading]: false,
  [candidateReferencesStateKeys.displayNewCandidateReferenceRequestForm]: false,
  [candidateReferencesStateKeys.candidateReferenceCountLimitReached]: false,
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_REFERENCES_SET_LOADING]: (state, { isLoading }) =>
    state.set(candidateReferencesStateKeys.isLoading, isLoading),

  [types.CANDIDATE_REFERENCES_SET_REFERENCES]: (state, { candidateReferences }) =>
    state.set(candidateReferencesStateKeys.candidateReferences, candidateReferences),

  [types.CANDIDATE_REFERENCES_SET_DISPLAY_NEW_REQUEST_FORM]: (state, { display }) =>
    state.set(candidateReferencesStateKeys.displayNewCandidateReferenceRequestForm, display),

  [types.CANDIDATE_REFERENCES_SET_COUNT_LIMIT_REACHED]: (state, { reached }) =>
    state.set(candidateReferencesStateKeys.candidateReferenceCountLimitReached, reached),

  [types.CANDIDATE_REFERENCES_SET_NOT_ENOUGH_REFERENCES_TO_APPLY]: (state, { enough }) =>
    state.set(candidateReferencesStateKeys.candidateReferenceCountEnoughToApply, enough),

  [types.CANDIDATE_REFERENCES_SET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR]: (state, { error }) =>
    state.set(candidateReferencesStateKeys.submitNewCandidateReferenceRequestError, error),

  [types.CANDIDATE_REFERENCES_RESET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR]: (state) =>
    state.set(candidateReferencesStateKeys.submitNewCandidateReferenceRequestError, null),


  [types.CANDIDATE_REFERENCES_RESET]: () => initialState
});

    



// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-references/candidate-references.js